import logo from './logo.svg';
import './App.css';

import {BrowserRouter as Router , Routes , Route , Link } from 'react-router-dom';

//import Home from "./pages/Home";
//import About from "./pages/About";
import MainRoute from "./pages/MainRoute";

function App() {
  return (
  <Router>
    <Routes>
      <Route path="/*" element={<MainRoute/>} />
    </Routes>
  </Router>
  );
}



/*    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
      <p>

      </p>
    </div>
    */




export default App;
